import { render, staticRenderFns } from "./LeadRemoveDialog.vue?vue&type=template&id=128b122d"
import script from "./LeadRemoveDialog.vue?vue&type=script&lang=ts"
export * from "./LeadRemoveDialog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports